import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

export const yardParkTab = createTab({
  slides: [
    {
      ...createDescription([
        'Наши ландшафтные архитекторы превращают дворы в приватное природное',
        'пространство — с множеством мест для приятных прогулок и отдыха, игр и спорта.',
      ]),
      imageAlt: 'Парк во дворе с озеленением в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/courtyard-park/1.webp`,
      markers: createSlideMarkers([
        {
          left: 490,
          tooltip: { placement: 'right', text: 'Взрослые деревья' },
          top: 509,
        },
        {
          left: 625,
          tooltip: { placement: 'right', text: 'Уличная мебель\nиз ангарской сосны' },
          top: 637,
        },
        {
          left: 306,
          tooltip: { placement: 'right', text: 'Детские площадки' },
          top: 652,
        },
        {
          left: 1213,
          tooltip: { placement: 'right', text: 'Безопасное\nпокрытие из резины' },
          top: 709,
        },
      ]),
    },
    {
      ...createDescription([
        'Зонируем пространство, продумываем озеленение и освещение, составляем маршруты так,',
        'чтобы каждый житель мог с удовольствием провести время на прогулке. Территория двора',
        'закрыта от автомобилей и посторонних, поэтому ничто не нарушает покой и досуг жителей.',
      ]),
      imageAlt: 'Маршруты для прогулок во дворе-парке Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/courtyard-park/2.webp`,
      markers: createSlideMarkers([
        {
          left: 521,
          tooltip: { placement: 'right', text: 'Всесезонное\nозеленение' },
          top: 580,
        },
        {
          left: 1200,
          tooltip: { placement: 'right', text: 'Ландшафтная подсветка' },
          top: 753,
        },
      ]),
    },
    {
      ...createDescription([
        'Площадки во дворе становятся настоящими точками притяжения. Большая песчаная зона —',
        'ваш собственный мини-пляж, а сад камней — идеальное место для созерцания и отдыха.',
        'Здесь можно устроить пикник с друзьями или поработать с ноутбуком на свежем воздухе.',
      ]),
      imageAlt: 'Зелёный парк во дворе в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/courtyard-park/3.webp`,
      markers: createSlideMarkers([
        {
          left: 281,
          tooltip: { placement: 'right', text: 'Плакучие ивы' },
          top: 611,
        },
        {
          left: 963,
          tooltip: { placement: 'right', text: 'Детская площадка' },
          top: 619,
        },
        {
          left: 697,
          tooltip: { placement: 'top', text: 'Большая\nпесчаная зона' },
          top: 639,
        },
        {
          left: 1250,
          tooltip: { placement: 'right', text: 'Сад камней' },
          top: 753,
        },
        {
          left: 806,
          tooltip: { placement: 'left', text: 'Место для пикника' },
          top: 874,
        },
      ]),
    },
    {
      ...createDescription([
        'Мы стремимся воссоздать атмосферу настоящего леса — экосистемы, в которую органично',
        'вписаны функциональные зоны. Благодаря такому подходу кажется, будто ландшафт создан',
        'самой природой, а не руками садовника.',
      ]),
      imageAlt: 'Пространство для отдыха во дворе-парке Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/courtyard-park/4.webp`,
      markers: createSlideMarkers([
        {
          left: 321,
          tooltip: { placement: 'right', text: 'Плакучая ива' },
          top: 300,
        },
        {
          left: 1253,
          tooltip: { placement: 'right', text: 'Скамейка для отдыха' },
          top: 678,
        },
        {
          left: 541,
          tooltip: { placement: 'right', text: 'Сад диких трав' },
          top: 823,
        },
      ]),
    },
  ],
  title: 'Парк во дворе',
});
